var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrownImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.145,
    height: 57.526,
    viewBox: "0 0 66.145 57.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_94560",
    "data-name": "Path 94560",
    d: "M62.877,23.823,51.426,25.884,36.207,3.82a3.32,3.32,0,0,0-5.27,0L15.718,25.884,4.267,23.823a3.2,3.2,0,0,0-3.644,4.03L9.158,57.725a3.2,3.2,0,0,0,3.078,2.321H54.909a3.2,3.2,0,0,0,3.078-2.321l8.535-29.872a3.2,3.2,0,0,0-3.644-4.03ZM52.5,53.645H14.649L8.189,31.033l8.426,1.517a3.211,3.211,0,0,0,3.2-1.334L33.572,11.273,47.328,31.216a3.207,3.207,0,0,0,3.2,1.334l8.426-1.517Z",
    transform: "translate(-0.5 -2.52)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownImage);
export default __webpack_public_path__ + "static/media/CrownImage.b1014b11e5ab238a5bc5d9234bd21416.svg";
export { ForwardRef as ReactComponent };